import { render, staticRenderFns } from "./SReadMore.vue?vue&type=template&id=ac25ba4a&scoped=true"
import script from "./sReadMore.ts?vue&type=script&lang=ts&external"
export * from "./sReadMore.ts?vue&type=script&lang=ts&external"
import style0 from "./SReadMore.vue?vue&type=style&index=0&id=ac25ba4a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac25ba4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac25ba4a')) {
      api.createRecord('ac25ba4a', component.options)
    } else {
      api.reload('ac25ba4a', component.options)
    }
    module.hot.accept("./SReadMore.vue?vue&type=template&id=ac25ba4a&scoped=true", function () {
      api.rerender('ac25ba4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-read-more/SReadMore.vue"
export default component.exports